<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Vehículos</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item">
                    <router-link to="/Admin">Administrativo</router-link>
                  </li>
                  <li class="breadcrumb-item active">General</li>
                  <li class="breadcrumb-item active">Vehículos</li>
                </ol>
              </div>
            </div>
          </div>
          <!-- /.container-fluid -->
        </section>
        <!-- Main content -->
        <section class="content">
          <div class="container-fluid">
            <!-- Header con botones de acción -->
            <div class="row">
              <div class="col-12">
                <div
                  class="card shadow-sm border-0"
                  :class="$store.getters.getDarkMode ? 'bg-dark' : 'bg-white'"
                >
                  <div
                    class="card-header border-0 py-3"
                    :class="
                      $store.getters.getDarkMode
                        ? 'bg-dark border-secondary'
                        : 'bg-light'
                    "
                  >
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <div>
                        <h5
                          class="mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-car me-2 text-primary"></i>
                          Gestión de Vehículos
                        </h5>
                        <p class="mb-0 text-muted small">
                          Administra la información de vehículos y sus
                          documentos
                        </p>
                      </div>
                      <div class="btn-group" role="group">
                        <button
                          type="button"
                          class="btn btn-outline-info"
                          @click="pivotTable()"
                          v-if="
                            $store.getters.can('admin.vehiculos.pivotTable')
                          "
                          data-bs-toggle="tooltip"
                          title="Vista de tabla dinámica"
                        >
                          <i class="fas fa-scroll me-1"></i>
                          Tabla Dinámica
                        </button>
                        <button
                          type="button"
                          class="btn btn-outline-success"
                          data-toggle="modal"
                          data-target="#modal_form_vehiculo_export"
                          v-if="$store.getters.can('admin.vehiculos.export')"
                          data-bs-toggle="tooltip"
                          title="Exportar a Excel"
                        >
                          <i class="far fa-file-excel me-1"></i>
                          Exportar
                        </button>
                        <button
                          type="button"
                          class="btn btn-primary"
                          v-if="$store.getters.can('admin.vehiculos.create')"
                          @click="create()"
                          data-bs-toggle="tooltip"
                          title="Crear nuevo vehículo"
                        >
                          <i class="fas fa-plus me-1"></i>
                          Nuevo Vehículo
                        </button>
                        <button
                          type="button"
                          class="btn btn-outline-secondary"
                          @click="getIndex()"
                          data-bs-toggle="tooltip"
                          title="Actualizar datos"
                        >
                          <i class="fas fa-sync-alt me-1"></i>
                          Actualizar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Sección de filtros -->
            <div class="row">
              <div class="col-12">
                <div
                  class="card"
                  :class="
                    $store.getters.getDarkMode
                      ? 'bg-dark border-secondary'
                      : 'bg-white'
                  "
                >
                  <div
                    class="card-header py-2"
                    :class="
                      $store.getters.getDarkMode
                        ? 'bg-dark border-secondary'
                        : 'bg-light'
                    "
                  >
                    <h6
                      class="mb-0"
                      :class="
                        $store.getters.getDarkMode ? 'text-light' : 'text-dark'
                      "
                    >
                      <i class="fas fa-filter me-2"></i>
                      Filtros de Búsqueda
                    </h6>
                  </div>
                  <div class="card-body py-3">
                    <div class="row">
                      <!-- Filtro Placa -->
                      <div class="col-md-6 col-lg-2">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-id-card me-1"></i>
                          Placa
                        </label>
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          v-model="filtros.placa"
                          @keyup="getIndex()"
                          placeholder="Buscar placa..."
                        />
                      </div>

                      <!-- Filtro Modelo -->
                      <div class="col-md-6 col-lg-2">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-calendar me-1"></i>
                          Modelo
                        </label>
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          v-model="filtros.modelo"
                          @change="getIndex()"
                          placeholder="Buscar modelo..."
                        />
                      </div>

                      <!-- Filtro Estado -->
                      <div class="col-md-6 col-lg-2">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-toggle-on me-1"></i>
                          Estado
                        </label>
                        <select
                          class="form-control form-control-sm"
                          v-model="filtros.estado"
                          @change="getIndex()"
                        >
                          <option value="">Todos...</option>
                          <option
                            v-for="estado in listasForms.estados"
                            :key="estado.numeracion"
                            :value="estado.numeracion"
                          >
                            {{ estado.descripcion }}
                          </option>
                        </select>
                      </div>

                      <!-- Filtro Líneas de Negocio -->
                      <div class="col-md-6 col-lg-3">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-briefcase me-1"></i>
                          Líneas de Negocio
                        </label>
                        <v-select
                          :class="
                            $store.getters.getDarkMode ? 'dark-vselect' : ''
                          "
                          v-model="linea_negocio"
                          label="nombre"
                          class="form-control form-control-sm p-0"
                          :options="listasForms.lineas_negocio"
                          :filterable="true"
                          multiple
                          @input="getIndex()"
                          placeholder="Seleccionar..."
                        ></v-select>
                      </div>

                      <!-- Filtro Estado Documentación -->
                      <div
                        class="col-md-6 col-lg-3"
                        v-if="linea_negocio.length != 0 || !linea_negocio"
                      >
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-file-alt me-1"></i>
                          Doc. (Estado)
                        </label>
                        <select
                          class="form-control form-control-sm"
                          v-model="filtros.estado_documentacion"
                          @change="getIndex()"
                        >
                          <option value="">Todos...</option>
                          <option value="Vencidos">Vencido</option>
                          <option value="Pendientes">Pendiente</option>
                          <option value="No verificados">No verificado</option>
                          <option value="Verificados">Verificado</option>
                          <option value="Sin_paquete">Sin paquete</option>
                          <option value="con_alertas"
                            >Con alertas (cualquiera)</option
                          >
                        </select>
                      </div>

                      <!-- Filtro Empresa -->
                      <div class="col-md-6 col-lg-3">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-building me-1"></i>
                          Empresa
                        </label>
                        <v-select
                          :class="
                            $store.getters.getDarkMode ? 'dark-vselect' : ''
                          "
                          v-model="listasForms.selct_empresa"
                          placeholder="Buscar empresa..."
                          label="razon_social"
                          class="form-control form-control-sm p-0"
                          :options="empresas"
                          :filterable="false"
                          @search="buscarEmpresas"
                          @input="getIndex()"
                        ></v-select>
                      </div>

                      <!-- Filtro Satelital -->
                      <div class="col-md-6 col-lg-2">
                        <label
                          class="form-label small mb-1"
                          :class="
                            $store.getters.getDarkMode
                              ? 'text-light'
                              : 'text-dark'
                          "
                        >
                          <i class="fas fa-satellite-dish me-1"></i>
                          Satelital
                        </label>
                        <select
                          class="form-control form-control-sm"
                          v-model="filtros.tiene_satelital"
                          @change="getIndex()"
                        >
                          <option value="">Todos...</option>
                          <option value="1">Sí tiene</option>
                          <option value="0">No tiene</option>
                        </select>
                      </div>

                      <!-- Botón limpiar filtros -->
                      <div class="col-md-12 col-lg-2 d-flex align-items-end">
                        <button
                          type="button"
                          class="btn btn-outline-secondary btn-sm w-100"
                          @click="limpiarFiltros()"
                        >
                          <i class="fas fa-eraser me-1"></i>
                          Limpiar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Contenido principal - Solo Tabla -->
            <div
              class="card"
              :class="
                $store.getters.getDarkMode
                  ? 'bg-dark border-secondary'
                  : 'bg-white'
              "
            >
              <div
                class="card-header py-2"
                :class="
                  $store.getters.getDarkMode
                    ? 'bg-dark border-secondary'
                    : 'bg-light'
                "
              >
                <div class="d-flex justify-content-between align-items-center">
                  <h6
                    class="mb-0"
                    :class="
                      $store.getters.getDarkMode ? 'text-light' : 'text-dark'
                    "
                  >
                    <i class="fas fa-table me-2"></i>
                    Lista de Vehículos
                  </h6>
                  <span class="badge bg-primary">
                    {{ vehiculos.total || 0 }} registros
                  </span>
                </div>
              </div>

              <div class="card-body p-0">
                <div class="table-responsive">
                  <table
                    class="table table-hover table-striped mb-0"
                    :class="$store.getters.getDarkMode ? 'table-dark' : ''"
                  >
                    <thead
                      class="text-center bg-dark"
                      :class="
                        $store.getters.getDarkMode
                          ? 'table-dark'
                          : 'table-light'
                      "
                    >
                      <tr>
                        <th class="text-center" style="width: 80px">
                          <i class="fas fa-image"></i>
                        </th>
                        <th
                          role="button"
                          @click="toggleSort('placa')"
                          :title="tooltipSort('placa')"
                        >
                          <i class="fas fa-id-card me-1"></i>
                          Placa
                          <span class="ms-1 small text-muted">{{
                            sortIcon("placa")
                          }}</span>
                        </th>
                        <th>
                          <i class="fas fa-tachometer-alt me-1"></i>
                          Odómetro
                        </th>
                        <th>
                          <i class="fas fa-briefcase me-1"></i>
                          Líneas
                        </th>
                        <th
                          role="button"
                          @click="toggleSort('empresa')"
                          :title="tooltipSort('empresa')"
                        >
                          <i class="fas fa-building me-1"></i>
                          Empresa
                          <span class="ms-1 small text-muted">{{
                            sortIcon("empresa")
                          }}</span>
                        </th>
                        <th>
                          <i class="fas fa-tag me-1"></i>
                          Marca
                        </th>
                        <th
                          role="button"
                          @click="toggleSort('modelo')"
                          :title="tooltipSort('modelo')"
                        >
                          <i class="fas fa-calendar me-1"></i>
                          Modelo
                          <span class="ms-1 small text-muted">{{
                            sortIcon("modelo")
                          }}</span>
                        </th>
                        <th
                          role="button"
                          @click="toggleSort('combustible')"
                          :title="tooltipSort('combustible')"
                        >
                          <i class="fas fa-gas-pump me-1"></i>
                          Combustible
                          <span class="ms-1 small text-muted">{{
                            sortIcon("combustible")
                          }}</span>
                        </th>
                        <th>
                          <i class="fas fa-car me-1"></i>
                          Tipo
                        </th>
                        <th>
                          <i class="fas fa-satellite-dish me-1"></i>
                          Último GPS
                        </th>
                        <th
                          role="button"
                          @click="toggleSort('estado_documentacion')"
                          :title="tooltipSort('estado_documentacion')"
                        >
                          <i class="fas fa-file-alt me-1"></i>
                          Documentos
                          <span class="ms-1 small text-muted">{{
                            sortIcon("estado_documentacion")
                          }}</span>
                        </th>
                        <th class="text-center">
                          <i class="fas fa-toggle-on me-1"></i>
                          Estado
                        </th>
                        <th class="text-center" style="width: 120px">
                          <i class="fas fa-cogs me-1"></i>
                          Acciones
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="vehiculo in vehiculosFiltrados"
                        :key="vehiculo.id"
                      >
                        <td class="text-center">
                          <a
                            v-if="vehiculo.link_fotografia"
                            :href="uri_docs + vehiculo.link_fotografia"
                            target="_blank"
                            class="d-inline-block"
                          >
                            <img
                              :src="uri_docs + vehiculo.link_fotografia"
                              alt="Vehículo"
                              class="rounded shadow-sm"
                              style="
                                width: 50px;
                                height: 50px;
                                object-fit: cover;
                              "
                            />
                          </a>
                          <div
                            v-else
                            class="d-flex align-items-center justify-content-center rounded"
                            :class="
                              $store.getters.getDarkMode
                                ? 'bg-secondary'
                                : 'bg-light'
                            "
                            style="width: 50px; height: 50px; margin: 0 auto"
                          >
                            <i class="fas fa-car text-muted"></i>
                          </div>
                        </td>
                        <td>
                          <span
                            class="fw-bold"
                            :class="
                              $store.getters.getDarkMode
                                ? 'text-light'
                                : 'text-dark'
                            "
                          >
                            {{ vehiculo.placa }}
                          </span>
                        </td>
                        <td>
                          <span
                            :class="
                              $store.getters.getDarkMode
                                ? 'text-light'
                                : 'text-dark'
                            "
                          >
                            {{ vehiculo.odometro }}
                          </span>
                        </td>
                        <td>
                          <div
                            v-if="
                              vehiculo.lineas_negocio &&
                                vehiculo.lineas_negocio.length > 0
                            "
                            class="d-flex flex-column gap-1"
                          >
                            <span
                              v-for="lineas in vehiculo.lineas_negocio"
                              :key="lineas.id"
                              class="badge bg-navy"
                            >
                              {{ lineas.nombre }}
                            </span>
                          </div>
                          <span v-else class="text-muted small"
                            >Sin líneas</span
                          >
                        </td>
                        <td>
                          <span
                            :class="
                              $store.getters.getDarkMode
                                ? 'text-light'
                                : 'text-dark'
                            "
                          >
                            {{
                              vehiculo.empresa != null
                                ? vehiculo.empresa.razon_social
                                : "No encontrada"
                            }}
                          </span>
                        </td>
                        <td>
                          <span class="badge bg-info">{{
                            vehiculo.nMarca
                          }}</span>
                        </td>
                        <td>
                          <span class="badge bg-secondary">{{
                            vehiculo.modelo
                          }}</span>
                        </td>
                        <td>
                          <span
                            :class="
                              $store.getters.getDarkMode
                                ? 'text-light'
                                : 'text-dark'
                            "
                          >
                            {{ vehiculo.nCombustible }}
                          </span>
                        </td>
                        <td>
                          <span
                            :class="
                              $store.getters.getDarkMode
                                ? 'text-light'
                                : 'text-dark'
                            "
                          >
                            {{
                              vehiculo.tipo_vehiculo_id
                                ? vehiculo.tipo_vehiculo.nombre
                                : ""
                            }}
                          </span>
                        </td>
                        <td>
                          <span
                            v-if="vehiculo.fecha_ultimo_gps"
                            :class="
                              $store.getters.getDarkMode
                                ? 'text-light'
                                : 'text-dark'
                            "
                            :title="
                              formatearFechaHora(vehiculo.fecha_ultimo_gps)
                            "
                          >
                            {{ formatearFechaHora(vehiculo.fecha_ultimo_gps) }}
                          </span>
                          <span v-else class="text-muted small"
                            >Sin registro</span
                          >
                        </td>
                        <td>
                          <div
                            v-if="
                              vehiculo.estado_documentos_lineas &&
                                vehiculo.estado_documentos_lineas.length > 0
                            "
                          >
                            <div
                              v-for="linea in vehiculo.estado_documentos_lineas"
                              :key="linea.linea_negocio_id"
                              class="mb-1"
                            >
                              <!-- Nombre línea -->
                              <div
                                class="small fw-bold text-muted mb-1 text-center"
                              >
                                {{ linea.linea_negocio }}
                              </div>

                              <!-- OK -->
                              <span
                                v-if="linea.estado === 'OK'"
                                class="d-flex flex-column gap-1"
                                title="Todos los documentos verificados"
                              >
                                <span class="badge bg-success"
                                  ><i class="fas fa-check me-1"></i>
                                  Verificados</span
                                >
                              </span>

                              <!-- SIN PAQUETE -->
                              <span
                                v-else-if="linea.estado === 'SIN_PAQUETE'"
                                class="d-flex flex-column gap-1"
                                title="Sin paquete de documentos asignado"
                              >
                                <span class="badge bg-secondary">
                                  <i class="fas fa-box-open me-1"></i> Sin
                                  paquete</span
                                >
                              </span>

                              <span v-else class="d-flex flex-column gap-1">
                                <span
                                  v-if="linea.estado === 'VENCIDOS'"
                                  class="badge bg-danger"
                                  :title="
                                    'Vencidos: ' + linea.vencidos.join(', ')
                                  "
                                >
                                  <i
                                    class="fas fa-exclamation-triangle me-1"
                                  ></i>
                                  Vencidos ({{ linea.vencidos.length }})
                                </span>

                                <span
                                  v-if="linea.estado === 'PENDIENTES'"
                                  class="badge bg-warning"
                                  :title="
                                    'Pendientes: ' + linea.pendientes.join(', ')
                                  "
                                >
                                  <i class="fas fa-clock me-1"></i>
                                  Pendientes ({{ linea.pendientes.length }})
                                </span>

                                <span
                                  v-if="linea.estado === 'NO_VERIFICADOS'"
                                  class="badge bg-info"
                                  :title="
                                    'No verificados: ' +
                                      linea.no_verificados.join(', ')
                                  "
                                >
                                  <i class="fas fa-question me-1"></i>
                                  No verificados ({{
                                    linea.no_verificados.length
                                  }})
                                </span>
                              </span>
                            </div>
                          </div>

                          <!-- Vehículo sin líneas -->
                          <div
                            v-else
                            class="d-flex flex-column align-items-center gap-1"
                          >
                            <div
                              class="small fw-bold text-muted mb-1 text-center"
                            >
                              No tiene
                            </div>

                            <span
                              class="badge bg-danger"
                              :title="'Linea de negocio no encontrada'"
                            >
                              <i class="fas fa-exclamation-triangle me-1"></i>
                              Linea de negocio asociada
                            </span>
                          </div>
                        </td>
                        <td class="text-center">
                          <span
                            class="badge"
                            data-toggle="modal"
                            data-target="#modal-form-estado"
                            style="cursor: pointer"
                            v-bind:class="[
                              vehiculo.estado == 1 ? 'bg-success' : 'bg-danger',
                            ]"
                            @click="llenarModal(vehiculo.id, vehiculo.estado)"
                          >
                            {{ vehiculo.estado == 1 ? "ACTIVO" : "INACTIVO" }}
                          </span>
                        </td>
                        <td class="text-center">
                          <div class="btn-group btn-group-sm" role="group">
                            <button
                              type="button"
                              class="btn btn-outline-primary"
                              v-if="
                                $store.getters.can(
                                  'admin.vehiculos.editarTransportadora',
                                ) && !admin
                              "
                              @click="edit(vehiculo, 3)"
                              title="Editar"
                            >
                              <i class="fas fa-edit"></i>
                            </button>
                            <button
                              type="button"
                              class="btn btn-outline-info"
                              v-else-if="
                                $store.getters.can('admin.vehiculos.show')
                              "
                              @click="edit(vehiculo, 1)"
                              title="Ver detalles"
                            >
                              <i class="fas fa-eye"></i>
                            </button>
                            <button
                              type="button"
                              class="btn btn-outline-primary"
                              v-if="
                                empresa.length > 0 &&
                                  vehiculo.tipo_propiedad == 1 &&
                                  vehiculo.empresa_id &&
                                  empresa[0].id == vehiculo.empresa_id &&
                                  $store.getters.can('admin.vehiculos.edit')
                              "
                              @click="edit(vehiculo, 2)"
                              title="Editar"
                            >
                              <i class="fas fa-edit"></i>
                            </button>
                            <button
                              type="button"
                              class="btn btn-outline-primary"
                              v-else-if="
                                (empresa.length === 0 ||
                                  vehiculo.tipo_propiedad != 1) &&
                                  $store.getters.can('admin.vehiculos.edit')
                              "
                              @click="edit(vehiculo, 2)"
                              title="Editar"
                            >
                              <i class="fas fa-edit"></i>
                            </button>
                            <button
                              type="button"
                              class="btn btn-outline-secondary"
                              v-if="$store.getters.can('admin.vehiculos.show')"
                              data-toggle="modal"
                              data-target="#modal-historial-estado"
                              @click="
                                llenarModalHistorial(
                                  'App\\Vehiculo',
                                  vehiculo.id,
                                )
                              "
                              title="Ver historial"
                            >
                              <i class="fas fa-history"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Mensaje cuando no hay datos -->
                <div
                  v-if="vehiculosFiltrados.length === 0"
                  class="text-center py-5"
                >
                  <h5 class="text-muted">No hay vehículos para mostrar</h5>

                  <div class="text-center py-4">
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Cargando...</span>
                    </div>
                    <p class="mt-2 text-muted">Cargando Vehículos..</p>
                  </div>
                </div>
              </div>
              <div
                class="card-footer border-0"
                :class="
                  $store.getters.getDarkMode
                    ? 'bg-dark border-secondary'
                    : 'bg-light'
                "
              >
                <div class="d-flex justify-content-between align-items-center">
                  <div v-if="vehiculos.total">
                    <p class="mb-0 small text-muted">
                      Mostrando del
                      <span class="fw-bold text-primary">{{
                        vehiculos.from
                      }}</span>
                      al
                      <span class="fw-bold text-primary">{{
                        vehiculos.to
                      }}</span>
                      de un total:
                      <span class="fw-bold text-primary">{{
                        vehiculos.total
                      }}</span>
                      registros
                    </p>
                  </div>
                  <div v-else>
                    <span class="badge bg-danger">
                      No hay registros para mostrar
                    </span>
                  </div>
                  <pagination
                    :data="vehiculos"
                    @pagination-change-page="getIndex"
                    :limit="5"
                    align="right"
                  >
                  </pagination>
                </div>
              </div>
            </div>
          </div>
        </section>
        <VehiculoEstado ref="VehiculoEstado" />
        <HistorialEstado ref="HistorialEstado" />
      </div>
    </div>
    <VehiculoExport ref="VehiculoExport" />
  </div>
</template>

<script>
import axios from "axios";
import pagination from "laravel-vue-pagination";
import VehiculoEstado from "./VehiculoEstado";
import HistorialEstado from "../historialEstado/HistorialEstado";
import VehiculoExport from "./VehiculoExport";
import vSelect from "vue-select";
import Loading from "../../../../components/Loading";

export default {
  name: "VehiculoIndex",
  components: {
    pagination,
    VehiculoEstado,
    VehiculoExport,
    HistorialEstado,
    vSelect,
    Loading,
  },
  data() {
    return {
      linea_negocio: [],
      empresas: [],
      empresa: this.$store.getters.getUser.empresas,
      tipo_vehiculo: [],
      user: null,
      admin: null,
      storageKeyFiltros: "admin_vehiculo_filtros",
      cargando: false,
      filtros: {
        placa: null,
        empresa: null,
        empresa_id: null,
        estado: null,
        estado_documentacion: "",
        modelo: null,
        marca: null,
        marca_id: null,
        combustible: null,
        combustible_id: null,
        tipo_vehiculo_id: null,
        tiene_satelital: null,
        sort_by: null,
        sort_dir: "asc",
      },
      vehiculos: {},
      listasForms: {
        empresas: [],
        tiposCarrocerias: [],
        estados: [],
        lineas_negocio: [],
        selct_empresa: [],
        marcas: [],
        combustibles: [],
        tipos_vehiculos: [],
      },
      combustible: null,
      marca: null,
      uri_docs: process.env.VUE_APP_AWS_BUCKET_URL,
    };
  },
  validations: {},
  computed: {
    vehiculosFiltrados() {
      const data = Array.isArray(this.vehiculos?.data)
        ? this.vehiculos.data
        : [];
      const filtro = (this.filtros?.estado_documentacion || "").toString();
      if (!filtro) return data;

      return data.filter((vehiculo) => {
        const vencidos = Array.isArray(vehiculo?.documentos_vencidos)
          ? vehiculo.documentos_vencidos.length
          : 0;
        const pendientes = Array.isArray(vehiculo?.documentos_pendientes)
          ? vehiculo.documentos_pendientes.length
          : 0;
        const noVerificados = Array.isArray(vehiculo?.documentos_no_verificados)
          ? vehiculo.documentos_no_verificados.length
          : 0;
        const paquetes = Array.isArray(vehiculo?.paquetes)
          ? vehiculo.paquetes.length
          : 0;

        switch (filtro) {
          case "vencidos":
            return vencidos > 0;
          case "pendientes":
            return pendientes > 0;
          case "no_verificados":
            return noVerificados > 0;
          case "verificado":
            return (
              vencidos === 0 &&
              pendientes === 0 &&
              noVerificados === 0 &&
              paquetes > 0
            );
          case "sin_paquete":
            return paquetes <= 0;
          case "con_alertas":
            return (
              vencidos > 0 ||
              pendientes > 0 ||
              noVerificados > 0 ||
              paquetes <= 0
            );
          default:
            return true;
        }
      });
    },
  },
  methods: {
    toggleSort(col) {
      if (!col) return;
      // Ciclo: sin orden -> asc -> desc -> sin orden
      if (this.filtros.sort_by !== col) {
        this.filtros.sort_by = col;
        this.filtros.sort_dir = "asc";
      } else if (this.filtros.sort_dir === "asc") {
        this.filtros.sort_dir = "desc";
      } else {
        this.filtros.sort_by = null;
        this.filtros.sort_dir = "asc";
      }
      this.getIndex(1);
    },
    sortIcon(col) {
      if (this.filtros.sort_by !== col) return "";
      return this.filtros.sort_dir === "asc" ? "▲" : "▼";
    },
    tooltipSort(col) {
      if (this.filtros.sort_by !== col) return "Ordenar ascendente";
      return this.filtros.sort_dir === "asc"
        ? "Ordenar descendente"
        : "Quitar orden";
    },
    formatearFechaHora(fecha) {
      if (!fecha) return "";
      const d = new Date(fecha);
      if (isNaN(d.getTime())) return fecha;
      return d.toLocaleString("es-AR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    getStoredFiltros() {
      try {
        const raw = sessionStorage.getItem(this.storageKeyFiltros);
        return raw ? JSON.parse(raw) : null;
      } catch (e) {
        return null;
      }
    },
    setStoredFiltros() {
      try {
        const f = this.filtros;
        const payload = {
          filtros: { ...f },
          linea_negocio: Array.isArray(this.linea_negocio)
            ? this.linea_negocio
                .map((l) =>
                  l && l.id ? { id: l.id, nombre: l.nombre || "" } : null,
                )
                .filter(Boolean)
            : [],
          selct_empresa:
            this.listasForms.selct_empresa && this.listasForms.selct_empresa.id
              ? {
                  id: this.listasForms.selct_empresa.id,
                  razon_social:
                    this.listasForms.selct_empresa.razon_social || "",
                }
              : null,
          marca: this.marca
            ? {
                numeracion: this.marca.numeracion,
                descripcion: this.marca.descripcion || "",
              }
            : null,
          combustible: this.combustible
            ? {
                numeracion: this.combustible.numeracion,
                descripcion: this.combustible.descripcion || "",
              }
            : null,
          tipo_vehiculo:
            this.tipo_vehiculo && this.tipo_vehiculo.id
              ? {
                  id: this.tipo_vehiculo.id,
                  nombre: this.tipo_vehiculo.nombre || "",
                }
              : null,
        };
        sessionStorage.setItem(this.storageKeyFiltros, JSON.stringify(payload));
      } catch (e) {
        // sessionStorage no disponible
      }
    },
    clearStoredFiltros() {
      try {
        sessionStorage.removeItem(this.storageKeyFiltros);
      } catch (e) {
        // sessionStorage no disponible
      }
    },
    getIndex(page = 1) {
      this.cargando = true;
      const stored = this.getStoredFiltros();
      if (stored && stored.filtros) {
        Object.assign(this.filtros, stored.filtros);
        this.linea_negocio = stored.linea_negocio || [];
        this.listasForms.selct_empresa = stored.selct_empresa || null;
        this.marca = stored.marca || null;
        this.combustible = stored.combustible || null;
        this.tipo_vehiculo = stored.tipo_vehiculo || null;
        this.clearStoredFiltros();
      } else {
        this.filtros.lineas_negocio = [];
        this.filtros.empresa_id = null;
        this.filtros.marca_id = null;
        this.filtros.combustible_id = null;
        this.linea_negocio.forEach((linea) => {
          this.filtros.lineas_negocio.push(linea.id);
        });
        if (this.listasForms.selct_empresa) {
          this.filtros.empresa_id = this.listasForms.selct_empresa.id;
        }
        if (this.marca) {
          this.filtros.marca_id = this.marca.numeracion;
        }
        if (this.combustible) {
          this.filtros.combustible_id = this.combustible.numeracion;
        }
        if (this.tipo_vehiculo) {
          this.filtros.tipo_vehiculo_id = this.tipo_vehiculo.id;
        }
      }
      axios
        .get("/api/admin/vehiculos?page=" + page, {
          params: this.filtros,
        })
        .then((response) => {
          this.vehiculos = response.data;
          this.cargando = false;
        });

      if (this.$store.state.user) {
        const administrador = this.$store.state.user.roles.find(
          (administrador) => administrador.id === 1,
        );
        if (administrador) {
          this.admin = administrador.id;
        }
      }
    },

    getLineasNegocio() {
      axios.get("/api/admin/lineasNegocios/lista").then((response) => {
        this.listasForms.lineas_negocio = response.data;
      });
    },

    getEmpresas() {
      axios
        .get("/api/admin/empresas/lista", { params: { pais_id: 1 } })
        .then((response) => {
          this.listasForms.empresas = response.data;
        });
    },

    getTiposCarrocerias() {
      axios.get("/api/lista/9").then((response) => {
        this.listasForms.tiposCarrocerias = response.data;
      });
    },

    getMarcas() {
      axios.get("/api/lista/12").then((response) => {
        this.listasForms.marcas = response.data;
      });
    },

    getTiposCombustible() {
      axios.get("/api/lista/24").then((response) => {
        this.listasForms.combustibles = response.data;
      });
    },

    getEstados() {
      axios.get("/api/lista/1").then((response) => {
        this.listasForms.estados = response.data;
      });
    },

    async getTiposVehiculos() {
      await axios.get("/api/admin/tiposVehiculos/lista").then((response) => {
        this.listasForms.tipos_vehiculos = response.data;
      });
    },

    buscarEmpresas(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "api/admin/empresas/lista?razon=" + search + "&pais_id=1";
        axios
          .get(url)
          .then(function(response) {
            let respuesta = response.data;
            me.empresas = respuesta;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrio un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    destroy(idVehiculo) {
      this.$swal({
        title: "Esta seguro de eliminar este Item?",
        text: "Los cambios no se pueden revertir!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, Eliminar!",
      }).then((result) => {
        if (result.value) {
          axios
            .delete("/api/admin/vehiculos/" + idVehiculo)
            .then((response) => {
              this.getIndex();
              this.$swal({
                icon: "success",
                title: "Se elimino el vehículo exitosamente...",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
            });
        }
      });
    },

    create() {
      return this.$router.push({
        name: "/Admin/VehiculoForm",
        params: { accion: "Crear", id: 0 },
      });
    },

    edit(vehiculo, opcion) {
      this.setStoredFiltros();
      return this.$router.push({
        name: "/Admin/VehiculoForm",
        params: {
          accion: "Editar",
          data_edit: vehiculo,
          id: vehiculo.id,
          opcion: opcion,
        },
      });
    },

    pivotTable() {
      return this.$router.push({
        name: "/Admin/VehiculoPivotTable",
      });
    },
    llenarModal(id, estado) {
      if (this.$store.getters.can("admin.vehiculos.editStatus")) {
        this.$refs.VehiculoEstado.llenar_modal(id, estado);
      }
    },

    llenarModalHistorial(entidad, entidad_id) {
      if (this.$store.getters.can("admin.vehiculos.show")) {
        this.$refs.HistorialEstado.llenar_modal(entidad, entidad_id);
      }
    },
    generarListadoExcel() {
      this.$parent.cargando = true;

      axios({
        method: "POST",
        url: "/api/admin/vehiculos/export",
        data: this.form,
      })
        .then((response) => {
          let data = response.data;
          this.$parent.cargando = false;
          location.href = data.url;
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error" + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.$parent.cargando = false;
        });
    },

    limpiarFiltros() {
      this.filtros = {
        placa: null,
        empresa: null,
        empresa_id: null,
        estado: null,
        modelo: null,
        marca: null,
        marca_id: null,
        combustible: null,
        combustible_id: null,
        tipo_vehiculo_id: null,
        tiene_satelital: null,
      };
      this.linea_negocio = [];
      this.listasForms.selct_empresa = null;
      this.marca = null;
      this.combustible = null;
      this.tipo_vehiculo = null;
      this.vehiculos = {};
      this.getIndex();
    },
  },
  mounted() {
    this.getIndex();
    this.getEmpresas();
    this.getTiposCarrocerias();
    this.getEstados();
    this.getLineasNegocio();
    this.getMarcas();
    this.getTiposCombustible();
    this.getTiposVehiculos();
  },
};
</script>
